// React Query hook for single-supplier detail — the enriched rollup, contracts
// and activity feed behind the supplier detail surface. Disabled until an id is
// supplied so it never fires for an empty route param.

import { useQuery } from "@tanstack/react-query";
import { suppliersApi } from "../services/api";

export function useSupplier(id: string) {
  return useQuery({
    queryKey: ["supplier", id],
    queryFn: () => suppliersApi.get(id),
    enabled: !!id,
  });
}
